// showChatList/openConversation were removed in Phase 10 (nav/routing
// consolidation) - navigating to "/chat" or "/chat/:conversationId" via
// react-router's useNavigate() now does what those functions used to do
// imperatively (ChatListRouteScreen.tsx/ChatThreadRouteScreen.tsx own the
// appState side effects that navigating there triggers).

export function initials(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return "?";
  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}

export function dateLabelFor(iso: string): string {
  const d = new Date(iso);
  const now = new Date();
  const startOfDay = (date: Date) => new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
  const diffDays = Math.round((startOfDay(now) - startOfDay(d)) / 86_400_000);

  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "Yesterday";
  if (diffDays > 1 && diffDays < 7) return d.toLocaleDateString(undefined, { weekday: "long" });
  return d.toLocaleDateString(undefined, {
    month: "long",
    day: "numeric",
    year: d.getFullYear() !== now.getFullYear() ? "numeric" : undefined,
  });
}

export const QUICK_REACTIONS = ["👍", "❤️", "😂", "😮", "😢", "🙏"];

// First-use discovery hint for the composer's ✨ "Things to do together"
// button - shown once, until the user actually opens the launcher (which
// itself proves they now understand what the icon does), never again
// after that. Same try/catch-guarded localStorage flag shape as
// installPrompt.ts's own dismissed()/setDismissed() (the only existing
// "seen this once, never show again" convention in this app).
const ACTIVITY_HINT_KEY = "chat-activity-hint-dismissed";

export function activityHintDismissed(): boolean {
  try {
    return localStorage.getItem(ACTIVITY_HINT_KEY) === "1";
  } catch {
    return false;
  }
}

export function dismissActivityHint(): void {
  try {
    localStorage.setItem(ACTIVITY_HINT_KEY, "1");
  } catch {
    // ignore
  }
}
